export const TXT_PT = 3.5;
export const TXT_PB = 2.5;
export const TXT_LABEL_HIDDEN_PT = 1.8;
export const TXT_LABEL_HIDDEN_PB = 1.6;
